import Layout4Admin1 from "components/layout/Layout4Admin1";
import Css from './Customer.module.css';
import ApiConection from "api_ref/ApiConection";
import { Button, Col, Form, InputGroup, Row } from "react-bootstrap";
import { ConvertDateToText, DisplayPaging } from "components/MyControl";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import UtilClass from "api_ref/UtilClass";

export default function PackagePeriod(){
    const api = new ApiConection();
    const nav = useNavigate();
    const util = new UtilClass();

    const [filterDispaly, setFilterDisplay] = useState(false);
    const [loading, setLoading] = useState(false);
    const [dataTable, setDataTable] = useState({
        arr_table: [],
        record_start: 0,
        record_end: 0,
        record_count: 0,
        page_count: 0
    });

    const [search, setSearch] = useState({
        name: '',
        short_name: '',
        is_default:'',
        is_show: '',
        active: '',
        page: util.getCombinedSessionStorage('/setting/config-packageperiod','page') ?? 1,
        size: util.getCombinedSessionStorage('/setting/config-packageperiod','size') ?? 10
    });

    const getData = async () => {
        let data = {
            search: {
            },
            pagination: {
                page: search.page,
                size: search.size
            }
        }

        if (search.name != '')
            data.search.Name = search.name;

        if (search.shortName != '')
            data.search.short_name = search.short_name;

        if (search.is_default != '')
            data.search.is_default = (search.is_default == true || search.is_default == 'true');
        
        if (search.active != '')
            data.search.active = (search.active == true || search.active == 'true');

        if (search.is_show != '')
            data.search.is_show = (search.is_show == true || search.is_show == 'true');
        setLoading(true);

        const response_pagination = await api.postData('api/PackagePeriod/Pagination', data);
        if (response_pagination.status === true) {
            handleSetDataTable('record_start', response_pagination.data.record_start);
            handleSetDataTable('record_count', response_pagination.data.record_count);
            handleSetDataTable('page_count', response_pagination.data.page_count);
        }

        const response_result = await api.postData(`api/PackagePeriod/result`, data);
        if (response_result.status == true) {
            handleSetDataTable('arr_table', response_result.data);
        } else {
            handleSetDataTable('arr_table', []);
        }

        let record_end = response_pagination.data.record_start + (search.size - 1);
            if (record_end > response_pagination.data.record_count) {
                record_end = response_pagination.data.record_count;
            }

            handleSetDataTable('record_end', record_end);

            setLoading(false);
    }


    const handleSetSearch = (name, value) => {
        setSearch(prevData => {
            return { ...prevData, [name]: value };
        });
    }

    const handleSetDataTable = (name, value) => {
        setDataTable(prevData => {
            return { ...prevData, [name]: value };
        });
    }

    const handleQuickSearch = (event) => {
        const { name, value } = event.target;
        handleSetSearch('name', value);
        handleSetSearch('page', 1);
        handleSetSearch('size', search.size);
    }

    const handleSizeTableChange = (event) => {
        const { name, value } = event.target;

        util.setCombinedSessionStorage('/setting/config-packageperiod','page',1);
        util.setCombinedSessionStorage('/setting/config-packageperiod','size',value);

        handleSetSearch('page', 1);
        handleSetSearch('size', value);
    }

    const handlePagingChange = (page_no) => {

        util.setCombinedSessionStorage('/setting/config-packageperiod','page',page_no);

        handleSetSearch('page', page_no);
    }

    const handleFullSearch = (event) => {
        const { name, value } = event.target;
        handleSetSearch(name, value);
        handleSetSearch('page', 1);
        handleSetSearch('size', search.size);
    }

    const handleDetail = (id) => {
        nav(`/setting/config-packageperiod/edit/${id}`);
    }

    const handleCreate = () => {
        nav('/setting/config-packageperiod/create')
    }

    useEffect(() => {
        if (search !== undefined) {
            const delay = setTimeout(() => {
                getData();
            }, 500);

            return () => clearTimeout(delay);
        }
    }, [search])


    return(
        <Layout4Admin1 role="admin">
            <div className={Css.Block_Transparent}>
                <div className={Css.Graph_Group}>
                    <div className={Css.Graph_Box + ' shadow'}>
                        <div className={Css.Content}>
                            <div className={Css.Header}>
                                <div className="d-flex">
                                    <h6 className="d-flex align-items-center">ตั้งค่าระยะเวลาแพ็กเกจ</h6>
                                    <div className="flex-fill">
                                        <Form.Group as={Row}>
                                            <Form.Label column sm={4} className="text-end">ค้นหา</Form.Label>
                                                <Col>
                                                    <InputGroup>
                                                        <Form.Control placeholder="ค้นหาที่นี่" id={'txtQuickSearch'} value={search.title}
                                                            disabled={filterDispaly}
                                                            onChange={(event) => handleQuickSearch(event)} />
                                                            <Button variant="outline-secondary" onClick={event => setFilterDisplay(!filterDispaly)}>
                                                                {
                                                                    filterDispaly === true &&
                                                                    <i className="fa-solid fa-arrow-up-short-wide"></i>
                                                                }
                                                                {
                                                                    filterDispaly === false &&
                                                                    <i className="fa-solid fa-arrow-down-short-wide"></i>
                                                                }
                                                                    <span></span>
                                                            </Button>
                                                            <Button>
                                                                <i className="fa-solid fa-magnifying-glass"></i>
                                                            </Button>
                                                    </InputGroup>

                                                </Col>
                                        </Form.Group>
                                    </div>
                                </div>
                                {
                                    filterDispaly === true &&
                                    <div className="d-flex bg-">
                                        <div className="w-100 bg-light p-3">
                                            <Row className="mb-2">
                                                <Col>
                                                    <Form.Label>ชื่อ</Form.Label>
                                                    <Form.Control name={'name'} value={search.name} onChange={handleFullSearch} />
                                                </Col>
                                                <Col>
                                                    <Form.Label>ชื่อย่อ</Form.Label>
                                                    <Form.Control name={'short_name'} value={search.short_name} onChange={handleFullSearch} />
                                                </Col>
                                                <Col>
                                                <Form.Label>ค่าเริ่มต้น</Form.Label>
                                                    <Form.Select name={'is_default'} value={search.is_default} onChange={handleFullSearch}>
                                                        <option value={''}>ทั้งหมด</option>
                                                        <option value={true}>อนุญาตใช้งาน</option>
                                                        <option value={false}>ไม่อนุญาตใช้งาน</option>
                                                    </Form.Select>
                                                </Col>
                                                <Col>
                                                <Form.Label>สถานะ</Form.Label>
                                                    <Form.Select name={'active'} value={search.active} onChange={handleFullSearch}>
                                                        <option value={''}>ทั้งหมด</option>
                                                        <option value={true}>อนุญาตใช้งาน</option>
                                                        <option value={false}>ไม่อนุญาตใช้งาน</option>
                                                    </Form.Select>
                                                </Col>
                                                <Col>
                                                <Form.Label>แสดงบนเว็บ</Form.Label>
                                                    <Form.Select name={'is_show'} value={search.is_show} onChange={handleFullSearch}>
                                                        <option value={''}>ทั้งหมด</option>
                                                        <option value={true}>อนุญาตใช้งาน</option>
                                                        <option value={false}>ไม่อนุญาตใช้งาน</option>
                                                    </Form.Select>
                                                </Col>
                                            </Row>
                                        </div>
                                    </div>
                                }
                            </div>
                            <div className={Css.Content + ' position-relative'}>
                                {
                                    loading &&
                                    <div className="position-absolute w-100 h-100 bg-white bg-opacity-50" style={{ zIndex: 5 }}>
                                        <div className="d-flex justify-content-center">
                                            <div className="spinner-border text-primary" role="status">
                                                <span className="visually-hidden">Loading...</span>
                                            </div>
                                        </div>
                                    </div>
                                }
                                <div className={Css.Content + ' position-relative'}>
                                    <Button variant="outline-success" className="d-flex justify-content-center" onClick={event => handleCreate()}>
                                        <i className="fa-solid fa-plus me-2 mt-1"></i>เพิ่มระยะเวลาแพ็กเกจ
                                    </Button>
                                </div>
                                <div className="table-responsive border rounded">
                                    <table className="table text-nowrap mb-0">
                                        <thead className="table-light">
                                            <tr>
                                                <th ></th>
                                                <th>#</th>
                                                <th className="text-start" >ชื่อ</th>
                                                <th className="text-start" >ชื่อย่อ</th>
                                                <th className="text-start" >หน่วยที่แสดง</th>
                                                <th className="text-start" >ค่าที่ใช้คำนวณ</th>
                                                <th>ค่าเริ่มต้น</th>
                                                <th>สถานะ</th>
                                                <th>แสดงบนเว็บ</th>
                                                <th className="text-start">วันที่สร้าง</th>
                                                <th className="text-start" >สร้างโดย</th>
                                                <th className="text-start">วันที่แก้ไข</th>
                                                <th className="text-start">แก้ไขโดย</th>
                                                
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                dataTable.arr_table.length > 0 &&
                                                dataTable.arr_table.map((obj, index) =>{
                                                    return (
                                                        <tr key={index}>
                                                            <td>
                                                                <button className="btn btn-edit-icon" onClick={event => handleDetail(obj.id)} >
                                                                        <i className="fa-solid fa-pen-to-square"></i>
                                                                </button>
                                                            </td>
                                                            <td>{dataTable.record_start + index}</td>
                                                            <td className="text-start">{obj.name}</td>
                                                            <td className="text-start">{obj.short_name}</td>
                                                            <td className="text-start">{obj.unit_name}</td>
                                                            <td className="text-start">{obj.multiply}</td>
                                                            <td className="text-center">{obj.is_default == true ? <i className="fa-regular fa-circle-check fs-6 text-success" title="สำเร็จ"></i>
                                                                : <i className="fa-regular fa-circle-xmark fs-6 text-danger" title="ไม่สำเร็จ"></i>}
                                                            </td>
                                                            <td className="text-center">{obj.active == true ? <i className="fa-regular fa-circle-check fs-6 text-success" title="สำเร็จ"></i>
                                                                : <i className="fa-regular fa-circle-xmark fs-6 text-danger" title="ไม่สำเร็จ"></i>}</td>
                                                            <td className="text-center">{obj.is_show == true ? <i className="fa-regular fa-circle-check fs-6 text-success" title="สำเร็จ"></i>
                                                                : <i className="fa-regular fa-circle-xmark fs-6 text-danger" title="ไม่สำเร็จ"></i>}</td>
                                                            <td className="text-start">{ConvertDateToText(obj.create_date)}</td>
                                                            <td className="text-start">{obj.create_by}</td>
                                                            <td className="text-start">{ConvertDateToText(obj.modify_date)}</td>
                                                            <td className="text-start">{obj.modify_by}</td>
                                                            
                                                        </tr>
                                                    )
                                                })
                                            }
                                        </tbody>
                                    </table>
                                </div>
                                <DisplayPaging rec_start={dataTable.record_start}
                                    rec_end={dataTable.record_end}
                                    rec_count={dataTable.record_count}
                                    onSizeChange={handleSizeTableChange}
                                    cur_page={search.page}
                                    size={search.size}
                                    page_count={dataTable.page_count}
                                    onPagingChange={handlePagingChange} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Layout4Admin1>
    )
}